import css from "./style.module.scss";

export default function Loader2() {
  return <span className={css.loader}></span>;
}
